import API from './utils/API'

const api = new API()

const fetchYoutubeVideos = ({ query, safeSearch, nextPageToken }) =>
  api
    .callApi({
      url: `/youtube/search`,
      method: 'post',
      data: { query, safeSearch, nextPageToken },
    })
    .then(({ data }) => data)

const fetchVideoDetails = (id) =>
  api
    .callApi({
      url: `/youtube/video/${id}`,
      method: 'get',
    })
    .then(({ data }) => data)

// Fetches the encrypted Embedder-Identity token required by YouTube's v2
// embedded player. The GCP API key stays server-side; we only receive `enc`.
const fetchEmbedToken = ({ videoId, contentFilter }) =>
  api
    .callApi({
      url: `/youtube/embed-token`,
      method: 'post',
      data: { videoId, contentFilter },
    })
    .then(({ data }) => data)

export default {
  fetchYoutubeVideos,
  fetchVideoDetails,
  fetchEmbedToken,
}
